import React from 'react';

const BranchFormModal = ({
  isDialogOpen,
  editingBranch,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
  organizations, // Lista de organizaciones para el selector
}) => {
  if (!isDialogOpen) return null;

  const title = editingBranch ? 'Editar Sucursal' : 'Crear Nueva Sucursal';

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, base64_logo: reader.result as string });
      };
      reader.readAsDataURL(file);
    }
  };

  const inputClass = 'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';
  const selectClass = 'focus:ring-primary-main bg-primary-main w-full rounded border px-3 py-2 focus:outline-none focus:ring';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 text-white">
      <div className="bg-primary-dark max-w-xl rounded p-6 shadow-lg sm:w-full max-h-[90vh] overflow-y-auto">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* Organización Padre */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium">Organización (Sede Central)</label>
              <select
                name="fk_organization"
                value={formData.fk_organization}
                onChange={handleFieldChange}
                className={selectClass}
                required
                disabled={!!editingBranch} // No se debe cambiar la organización padre una vez creada
              >
                <option value="">Selecciona una Organización</option>
                {organizations.map((org) => (
                  <option key={org._id} value={org._id}>
                    {org.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Nombre de Sucursal */}
            <div>
              <label className="block text-sm font-medium">Nombre de la Sucursal</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Nombre Corto */}
            <div>
              <label className="block text-sm font-medium">Nombre Corto</label>
              <input
                type="text"
                name="short_name"
                value={formData.short_name}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* OID (Identificador Único) */}
            <div>
              <label className="block text-sm font-medium">OID</label>
              <input
                type="text"
                name="oid"
                value={formData.oid}
                onChange={handleFieldChange}
                className={inputClass}
                required
                disabled={!!editingBranch} // OID es inmutable
              />
            </div>
            {/* Código de País */}
            <div>
              <label className="block text-sm font-medium">Código de País</label>
              <input
                type="text"
                name="country_code"
                value={formData.country_code}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* ID de Estructura */}
            <div>
              <label className="block text-sm font-medium">ID de Estructura</label>
              <input
                type="text"
                name="structure_id"
                value={formData.structure_id}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Sufijo Legal */}
            <div>
              <label className="block text-sm font-medium">Sufijo</label>
              <input
                type="text"
                name="suffix"
                value={formData.suffix}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>

            {/* Base64 Logo (Opcional) */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium">Logotipo (Opcional)</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="block w-full text-sm text-gray-400
                  file:mr-4 file:py-2 file:px-4
                  file:rounded file:border-0
                  file:text-sm file:font-semibold
                  file:bg-primary-main file:text-white
                  hover:file:bg-primary-light"
              />
              {formData.base64_logo && (
                <div className="mt-2">
                  <p className="text-xs text-gray-400 mb-1">Vista previa:</p>
                  <img
                    src={formData.base64_logo}
                    alt="Logo Preview"
                    className="h-16 object-contain border border-gray-700 p-1 bg-white"
                  />
                </div>
              )}
            </div>

          </div>

          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={resetForm}
              className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900"
            >
              {editingBranch ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BranchFormModal;
